import { useRolodexEntries } from 'features/rolodex'
import {
  API570WeldType,
  ForecastComponentConfig,
  GeckoEntryBase,
  RolodexEntryType,
} from 'types'

/**
 * A simple fetcher to get the forecast component config for a given `componentSlug`
 */
export function useGetForecastComponentConfig(componentSlug: string | null): {
  entries: ReadonlyArray<GeckoEntryBase<ForecastComponentConfig>>
  isLoading: boolean
  forceRefresh: () => Promise<void>
} {
  return useRolodexEntries(
    componentSlug
      ? {
          type: RolodexEntryType.FDE_FORECAST_COMPONENT_CONFIG,
          tags: { component: componentSlug },
        }
      : undefined,
    { allowCache: false }
  )
}

export const API570WeldTypeLabels: Record<API570WeldType, string> = {
  'dbl-welded-full-radio': 'Double-Welded Butt Joint (Fully Radiographed)',
  'dbl-welded-spot-radio': 'Double-Welded Butt Joint (Spot Radiographed)',
  'dbl-welded-no-radio': 'Double-Welded Butt Joint (No Radiography)',
  'sngl-welded-full-radio':
    'Single-Welded Butt Joint with Backing (Fully Radiographed)',
  'sngl-welded-spot-radio':
    'Single-Welded Butt Joint with Backing (Spot Radiographed)',
  'sngl-welded-no-radio':
    'Single-Welded Butt Joint with Backing (No Radiography)',
}

export const API570WeldTypeJointEfficiencies: Record<API570WeldType, number> = {
  'dbl-welded-full-radio': 1.0,
  'dbl-welded-spot-radio': 0.85,
  'dbl-welded-no-radio': 0.7,
  'sngl-welded-full-radio': 1.0,
  'sngl-welded-spot-radio': 0.85,
  'sngl-welded-no-radio': 0.7,
}

// ======================================== exported type ========================================

export const ForecastComponentConfigDefaults = {
  specific_gravity: 1,
  upper_courses_stress_tolerance: 27000,
  lower_courses_stress_tolerance: 26000,
  joint_efficiency: 1,
  shell_course_elevations: [],
}
